import { Divider, Grid } from '@mui/material';
import React from 'react';
import { type Slide } from '../../_data';
import { EditableField } from '../../components/EditableField';

export type SampleModelDifferencesContentType = [
  {
    field: 'title';
    label: string;
    value: string;
    type: 'editableTextarea';
  },
  {
    field: 'subtitle1';
    label: string;
    value: string;
    type: 'editableTextarea';
  },
  {
    field: 'bulletPointsOption1';
    label: string;
    value: Record<number, string>;
    type: 'editableTextarea';
  },
  {
    field: 'subtitle2';
    label: string;
    value: string;
    type: 'editableTextarea';
  },
  {
    field: 'bulletPointsOption2';
    label: string;
    value: Record<number, string>;
    type: 'editableTextarea';
  },
];

export const SampleModelDifferencesContent = React.memo(
  ({
    slide,
    onChangeSlide,
  }: {
    slide: Slide<SampleModelDifferencesContentType>;
    onChangeSlide: (
      slide: Slide<SampleModelDifferencesContentType>,
      content: SampleModelDifferencesContentType,
    ) => void;
  }): React.ReactElement => {
    return (
      <Grid
        container
        direction="row"
        sx={{
          height: '100%',
          width: '100%',
        }}
      >
        <Grid
          container
          direction="row"
          sx={{
            width: '100%',
            height: 'calc(100% - 30px)',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              textAlign: 'left',
              fontFamily: 'Roboto',
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#004F7E',
              padding: '20px',
            }}
          >
            <EditableField
              field="title"
              slide={slide}
              onSlideContentChange={onChangeSlide}
              editorClassName="slide25_title"
            />
            <Divider style={{ marginTop: '20px' }} />
            <Grid container spacing={2} mt={5}>
              <Grid item xs={6}>
                <EditableField
                  field={'subtitle1'}
                  slide={slide}
                  onSlideContentChange={onChangeSlide}
                  style={{
                    fontSize: '28px',
                    color: '#004F7E',
                    fontFamily: 'Roboto',
                    fontWeight: '500',
                    width: '100%',
                  }}
                  editorClassName="slide25"
                />
                <EditableField
                  field={'bulletPointsOption1'}
                  slide={slide}
                  onSlideContentChange={onChangeSlide}
                  style={{
                    fontSize: '20px',
                    fontFamily: 'Roboto',
                    fontWeight: '400',
                    color: '#000000',
                    width: '100%',
                  }}
                  editorClassName="slide25"
                />
              </Grid>
              <Grid item xs={6}>
                <EditableField
                  field={'subtitle2'}
                  slide={slide}
                  onSlideContentChange={onChangeSlide}
                  style={{
                    fontSize: '28px',
                    fontWeight: '500',
                  }}
                  editorClassName="slide25"
                />
                <EditableField
                  field={'bulletPointsOption2'}
                  slide={slide}
                  onSlideContentChange={onChangeSlide}
                  style={{
                    fontSize: '20px',
                    fontWeight: '400',
                    color: '#000000',
                    fontFamily: 'Roboto',
                  }}
                  editorClassName="slide25"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  },
);

export default SampleModelDifferencesContent;
